import { assignUsersToPatron } from "api/services/user-service";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { useCallback } from "react";

export const useAssignUsersToPatron = () => {
    const { callAPI, loading } = useWorkspaceApiCall(assignUsersToPatron, 'assignUsersToPatron.success', 'assignUsersToPatron.error');

    const assignUsersToPatronMethod = useCallback(async (patronIds: string[], userIds: string[]) => {
        const resp = await callAPI({ patronIds, userIds });
        return resp;
    }, [callAPI]);
    
    return { assignUsersToPatron: assignUsersToPatronMethod, assigningUsersToPatron: loading };
}